"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditOffersList = void 0;
var react_1 = __importDefault(require("react"));
var CreditOffersList_module_scss_1 = __importDefault(require("./CreditOffersList.module.scss"));
var CreditOffer_1 = require("../creditOffer/CreditOffer");
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var Loader_1 = require("../loader/Loader");
var CreditOffersList = function (props) {
    var payment = props.payment;
    var error = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).stateLoad.error;
    var isLoad = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).stateLoad.isLoad;
    var bestOffers = (0, react_redux_1.useSelector)(selectors_1.banksListSelector).bestOffersBanks;
    if (isLoad) {
        return react_1.default.createElement(Loader_1.Loader, null);
    }
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445");
    }
    return (react_1.default.createElement("section", { className: CreditOffersList_module_scss_1.default.credit_offers },
        react_1.default.createElement("h2", { className: CreditOffersList_module_scss_1.default.credit_offers__title }, "\u041B\u0443\u0447\u0448\u0438\u0435 \u043A\u0440\u0435\u0434\u0438\u0442\u043D\u044B\u0435 \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u044F"),
        react_1.default.createElement("div", { className: CreditOffersList_module_scss_1.default.credit_offers__list }, bestOffers.map(function (bank) {
            return react_1.default.createElement(CreditOffer_1.CreditOffer, { key: bank.id, bank: bank, payment: payment });
        }))));
};
exports.CreditOffersList = CreditOffersList;
